export default function About(){
    return(
        <p>
            I'm Mohamed, an enthusiast Web Developer from Iraq. My first encounter with Web Development was back in the days of my first year at college, and since then Web Development is something that I do every day. I love coding and improving my skills each day.
        </p>
    )
}